class ShapePoint {
    constructor(options = {
        x: 0,
        y: 0,
        screenY: 0,
        time: 0,
        loopTime: 0,
        instrument: 0,
        color: '',
        hexColor: '',
        radius: 0,
        hairs: [],
        strokeIndex: 0,
        p1x: 0,
        p1y: 0,
        p2x: 0,
        p2y: 0,
        isStamp: false,
        index: 0,
        id: -1
    }) {
        this.index = options.index;
        this.x = options.x;
        this.y = options.y;
        this.screenY = options.screenY;
        this.time = options.time || 0;
        this.loopTime = options.loopTime || 0;
        this.instrument = options.instrument || 0;
        this.color = options.color;
        this.hexColor = options.hexColor || '';
        this.radius = options.radius || 0;
        this.hairs = options.hairs || [];
        this.strokeIndex = options.strokeIndex || 0;
        this.p1x = options.p1x;
        this.p1y = options.p1y;
        this.p2x = options.p2x;
        this.p2y = options.p2y;
        this.isStamp = options.isStamp || false;
        this.id = options.id || -1;
    }
}
export { ShapePoint };